<div *ngIf="params.data && !params.data.editable">
    <input type="checkbox" [(ngModel)]="params.data.active" disabled >
</div>
<div *ngIf="params.data && params.data.editable">
    <input type="checkbox" [(ngModel)]="params.data.active">
</div>